import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
import CardActions from "@material-ui/core/CardActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Pagination from "@material-ui/lab/Pagination";
// core componentssrc
import { IconButton, Tooltip, useTheme } from "@material-ui/core";
import { useQuery } from "@tanstack/react-query";
import componentStylesGeneric from "assets/theme/views/admin/generic";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import { getFilteredWorkcentersSnapshot } from "crud/rent.crud";
import { ConditionGuard } from "guards/ConditionGuard";
import moment from "moment";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { PAGINATION } from "utils/const";

const useStylesGeneric = makeStyles(componentStylesGeneric);

export const ConfirmationWorkCenterTable = ({ onOpenDetails, detailsEnabled = false }) => {
  const classes = useStylesGeneric();

  const theme = useTheme();

  const [pageIndex, setPageIndex] = useState(PAGINATION.FIRST_PAGE);

  const { id } = useParams();

  const { data, isFetching } = useQuery(
    ["rent", "workcentersSnapshot", id, { pageIndex: pageIndex, pageSize: 15 }],
    () =>
      getFilteredWorkcentersSnapshot({
        id,
        pageIndex: pageIndex,
        pageSize: 15,
      }),
    {
      staleTime: 0,
      refetchOnMount: true,
      select: (response) => {
        if (!response) return {};

        return {
          data: response.data,
          totalCount: response.totalCount,
          totalPages: response.totalPages,
        };
      },
    }
  );

  const tableHead = [
    "Data de Registo",
    "Nome do Centro",
    "Província",
    "Munícipio",
    "Actividade",
  ];

  return (
    <>
      <CardTableContainer title={"Lista de centros registados na sua empresa"} count={data?.totalCount}>
        <TableContainer>
          <ConditionGuard condition={!isFetching} fallback={<TableBackdrop open />}>
            <Box component={Table} alignItems="center" marginBottom="0!important">
              <TableHead>
                <TableRow>
                  {tableHead.map((prop, key) => (
                    <TableCell
                      key={key}
                      classes={{
                        root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                      }}
                    >
                      {prop}
                    </TableCell>
                  ))}

                  <ConditionGuard condition={detailsEnabled}>
                    <TableCell
                      key="detailsCol"
                      classes={{
                        root:
                          classes.tableCellRoot +
                          " " +
                          classes.tableCellRootHead +
                          " " +
                          classes.tableCellHeadStickyRight,
                      }}
                    >
                      Detalhes
                    </TableCell>
                  </ConditionGuard>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.data?.map((prop, key) => (
                  <TableRow key={key}>
                    <TableCell classes={{ root: classes.tableCellRoot }}>
                      {moment(prop.created).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.name}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.province}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.municipality}</TableCell>
                    <TableCell classes={{ root: classes.tableCellRoot }}>{prop.secundaryActivity}</TableCell>

                    <ConditionGuard condition={detailsEnabled}>
                      <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellBodyStickyRight }}>
                        <Tooltip title="Detalhes">
                          <IconButton onClick={() => onOpenDetails(prop?.id)}>
                            <Box
                              component={ArrowForwardIosIcon}
                              width="12px!important"
                              height="12px!important"
                              color={theme.palette.primary.main}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </ConditionGuard>
                  </TableRow>
                ))}
              </TableBody>
            </Box>
          </ConditionGuard>
        </TableContainer>

        {!isFetching && data?.data?.length === 0 && (
          <Box classes={{ root: classes.noResultsInfo }}>Não foram encontrados resultados.</Box>
        )}

        <Box classes={{ root: classes.cardActionsRoot }} component={CardActions} justifyContent="flex-end"></Box>

        <Pagination
          className={classes.alignPagination}
          count={data?.totalPages}
          page={pageIndex}
          onChange={(_, value) => {
            setPageIndex(value);
          }}
          color="primary"
        />
      </CardTableContainer>
    </>
  );
};
